import { render, staticRenderFns } from "./chooseShop.vue?vue&type=template&id=34f9795d&scoped=true"
import script from "./chooseShop.vue?vue&type=script&lang=js"
export * from "./chooseShop.vue?vue&type=script&lang=js"
import style0 from "./chooseShop.vue?vue&type=style&index=0&id=34f9795d&prod&lang=less&scoped=true"
import style1 from "./chooseShop.vue?vue&type=style&index=1&id=34f9795d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f9795d",
  null
  
)

export default component.exports